import { render, staticRenderFns } from "./juxue.vue?vue&type=template&id=355a1e79&scoped=true"
import script from "./juxue.vue?vue&type=script&lang=js"
export * from "./juxue.vue?vue&type=script&lang=js"
import style0 from "./juxue.vue?vue&type=style&index=0&id=355a1e79&prod&lang=css"
import style1 from "./juxue.vue?vue&type=style&index=1&id=355a1e79&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355a1e79",
  null
  
)

export default component.exports